import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import { Button } from "flowbite-react";
import { DownloadSimple, FilePdf, X } from "@phosphor-icons/react";
import { useModal } from "context/ModalContext";
import {
  downloadCoupon,
  isPdfCoupon,
  parseCouponDate,
  PlayerCoupon,
} from "services/coupon.service";

export function CouponModal() {
  ReactModal.setAppElement("#modal");

  const modalID = "coupon";

  const [modalIsOpen, setIsOpen] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const { openModal, closeModal, modalData } = useModal();

  const coupon: PlayerCoupon | undefined = modalData;

  useEffect(() => {
    setIsOpen(openModal === modalID);
    setFullscreen(false);
  }, [openModal, modalData]);

  if (!coupon) return null;

  const isPdf = isPdfCoupon(coupon);
  const assignedDate = parseCouponDate(coupon.assigned);

  return (
    <ReactModal
      shouldCloseOnOverlayClick={false}
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      contentLabel="Coupon Modal"
      portalClassName="relative z-40"
      overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      contentElement={() => (
        <div>
          <div className="bg-white rounded-xl p-3 px-5 w-[450px] max-w-[97vw] max-h-[90vh] overflow-y-auto flex flex-col items-center flex-none mx-5 gap-2">
            <h1 className="text-xl lg:text-3xl mt-4 font-bold text-blue-500 text-center">
              Tu cupón
            </h1>
            <p className="text-center font-bold text-orange-500 leading-tight">
              {coupon.item?.name}
            </p>
            {assignedDate && (
              <small className="text-gray-500">
                Canjeado el {assignedDate.toLocaleDateString("es")}
              </small>
            )}

            {isPdf ? (
              <div className="flex flex-col items-center gap-2 border rounded-xl p-5 my-3 w-full">
                <FilePdf size={64} className="text-brand-red" />
                <p className="text-center text-sm text-gray-600 break-all">
                  {coupon.filename}
                </p>
                <Button
                  type="button"
                  onClick={() => window.open(coupon.url, "_blank", "noopener")}
                  className="bg-brand-purple"
                >
                  VER CUPÓN (PDF)
                </Button>
              </div>
            ) : (
              <button
                type="button"
                className="my-3 w-full"
                onClick={() => setFullscreen(true)}
              >
                <img
                  src={coupon.url}
                  alt={coupon.item?.name}
                  className="w-full max-h-[45vh] object-contain rounded-lg border"
                />
                <small className="text-gray-500">
                  Toca el cupón para verlo en pantalla completa
                </small>
              </button>
            )}

            <p className="text-center text-sm text-gray-600 leading-tight">
              Presenta este cupón en el establecimiento del socio.
            </p>

            <div className="py-3 relative z-10 flex gap-3">
              <Button
                type="button"
                onClick={() => downloadCoupon(coupon)}
                className="bg-brand-green whitespace-nowrap"
              >
                <DownloadSimple size={20} />
                <b className="ml-2">DESCARGAR</b>
              </Button>
              <Button
                type="button"
                onClick={closeModal}
                className="bg-brand-red"
              >
                CERRAR
              </Button>
            </div>
          </div>

          {fullscreen && !isPdf && (
            <div
              className="fixed top-0 left-0 w-full h-full z-50 bg-white flex items-center justify-center"
              onClick={() => setFullscreen(false)}
            >
              <img
                src={coupon.url}
                alt={coupon.item?.name}
                className="max-w-full max-h-full object-contain"
              />
              <button
                type="button"
                className="absolute top-3 right-3 bg-gray-100 rounded-full p-2"
                onClick={() => setFullscreen(false)}
              >
                <X size={28} />
              </button>
            </div>
          )}
        </div>
      )}
    />
  );
}
